export default __webpack_public_path__ + "static/media/relegation.c10212a0.webp";